module.exports = __webpack_public_path__ + "static/img/cocina_14.f4088c35.png";